<template>
  <div v-if="visible">
    <span v-if="days">{{days}}:</span>
    <span v-if="days || hours">{{hours | twoDigit}}:</span>
    <span v-if="days || hours || minutes">{{minutes | twoDigit}}:</span>
    {{seconds | twoDigit}}
  </div>
</template>

<script>
    export default {
        name: "CountdownTimer",
        props: {
            date: Object,
            visible: {
                default: false,
                type: Boolean
            }
        },
        data() {
            return {
                days: '',
                hours: '',
                minutes: '',
                seconds: '',
                timer: '',
            }
        },
        computed: {
            countDownDate() {
                return new Date(this.date.year,this.date.month - 1, this.date.day, this.date.hour, this.date.minute).getTime();
            }
        },
        methods: {
            calcTimer() {
                const now = new Date().getTime();
                const distance = this.countDownDate - now;

                this.days = Math.floor(distance / (1000 * 60 * 60 * 24));
                this.hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                this.minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                this.seconds = Math.floor((distance % (1000 * 60)) / 1000);

                return distance
            },
            start() {
                let that = this;
                if (that.calcTimer() < 0) {
                    that.$emit('finished')
                }
                this.timer = setInterval(function () {
                    if (that.calcTimer() < 0) {
                        clearInterval(that.timer);
                        that.$emit('finished')
                    }
                }, 1000);
            },
            stop() {
                clearInterval(this.timer)
            }
        },
        filters: {
            twoDigit: function (value) {
                if (value > 9) return value
                value = value.toString()
                return '0' + value
            }
        }
    }
</script>

<style scoped>

</style>
